var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 0H2.34375C1.05469 0 0 1.05469 0 2.34375V22.6562C0 23.9453 1.05469 25 2.34375 25H22.6562C23.9453 25 25 23.9453 25 22.6562V2.34375C25 1.05469 23.9453 0 22.6562 0ZM17.1875 3.90625C17.1875 3.47656 17.5391 3.125 17.9688 3.125H21.0938C21.5234 3.125 21.875 3.47656 21.875 3.90625V7.03125C21.875 7.46094 21.5234 7.8125 21.0938 7.8125H17.9688C17.5391 7.8125 17.1875 7.46094 17.1875 7.03125V3.90625ZM12.5 7.8125C15.0875 7.8125 17.1875 9.9125 17.1875 12.5C17.1875 15.0875 15.0875 17.1875 12.5 17.1875C9.9125 17.1875 7.8125 15.0875 7.8125 12.5C7.8125 9.9125 9.9125 7.8125 12.5 7.8125ZM21.875 21.0938C21.875 21.5234 21.5234 21.875 21.0938 21.875H3.90625C3.47656 21.875 3.125 21.5234 3.125 21.0938V10.9375H4.84375C4.74062 11.4406 4.6875 11.9625 4.6875 12.5C4.6875 16.8156 8.18281 20.3125 12.5 20.3125C16.8172 20.3125 20.3125 16.8156 20.3125 12.5C20.3125 11.9625 20.2594 11.4406 20.1562 10.9375H21.875V21.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.27e7490620c8b7f842666de0a8456212.svg";
export { ForwardRef as ReactComponent };